module.exports = require("lodash/some");